'use strict';

import React from 'react';

export default function IconTrust (props) {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.000605155 2.93887C2.97286 2.40222 7.00884 0 7.00884 0C7.00884 0 11.9606 2.62183 13.9982 2.92575C13.9982 2.92575 14.0907 6.65829 12.9655 9.87218C12.5819 10.9677 11.2254 12.5417 10.066 13.4648C9.11367 14.223 7.00884 15 7.00884 15C7.00884 15 2.46533 13.4648 1.06199 9.77313C-0.0611118 6.81871 0.000605155 2.93887 0.000605155 2.93887ZM3.5634 6.81761L4.82336 5.47416L6.69319 7.85972C8.2229 5.13686 11.0644 1.96668 11.0644 1.96668L12.4595 2.50593C12.4595 2.50593 9.80107 5.14317 6.79973 11.521C6.78786 11.5462 6.69628 11.3735 6.53752 11.0741C6.05305 10.1606 4.94298 8.06725 3.5634 6.81761Z" fill="#94C133"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconTrust.jsx